import React from "react";

import CheckpointMD from "@busbud/design-system-components/dist/Icons/Checkpoint/MD";
import CheckpointSM from "@busbud/design-system-components/dist/Icons/Checkpoint/SM";
import Stack from "@busbud/design-system-components/dist/Stack";
import type { ResponsiveColorProp } from "@busbud/design-system-components/dist/system/palette";

import type { CheckpointPathIconVariant, LineVariant } from "../types";

import { useStyles } from "./checkpoint-path.styles";
import { Line } from "./line";

interface Props {
  class_name?: string;
  icon?: React.ReactNode;
  has_icon?: boolean;
  has_line?: boolean;
  line_color?: ResponsiveColorProp;
  line_variant?: LineVariant;
  variant?: CheckpointPathIconVariant;
}

export const CheckpointPath: React.FC<Props> = ({
  class_name,
  icon,
  has_icon = true,
  has_line = true,
  line_color = "border.primary.opaque",
  line_variant,
  variant = "major"
}) => {
  const { cx, classes } = useStyles();

  const Icon = variant === "major" ? CheckpointMD : CheckpointSM;

  return (
    <Stack
      direction="column"
      alignItems="center"
      className={cx(classes.container, class_name)}
      color={line_color} // `Line` inherit this color by using `currentColor`.
    >
      {!!(has_icon || icon) &&
        (icon || <Icon variant={variant} color="icon.primary.opaque" />)}
      {!!has_line && <Line class_name={classes.line} variant={line_variant} />}
    </Stack>
  );
};
